export const OHL = {
    name: 'DV 102B/2 TS POŽAREVAC - TS PETROVAC',
    voltage: '110',
    regionCode: 'BGD',
    stanice: [],
    position: 'S',
    stubovi: [
        { index: 1, name: 'P-05', lat: 44.6539 , lng: 21.1897, sys: 1, portal: true},
        { index: 2, name: '41', lat: 44.6534 , lng: 21.1905, sys: 2},
        { index: 3, name: '42', lat: 44.6522 , lng: 21.1934, sys: 2},
        { index: 4, name: '43', lat: 44.651 , lng: 21.1961, sys: 2},
        { index: 5, name: '44', lat: 44.65 , lng: 21.1983, sys: 2},
        { index: 6, name: '45', lat: 44.6491 , lng: 21.2002, sys: 2},
        { index: 7, name: '46', lat: 44.6481 , lng: 21.2032, sys: 2},
        { index: 8, name: '47', lat: 44.647 , lng: 21.2064, sys: 2},
        { index: 9, name: '48', lat: 44.6459 , lng: 21.2096, sys: 2},
        { index: 10, name: '49', lat: 44.6448 , lng: 21.2128, sys: 2},
        { index: 11, name: '50', lat: 44.6437 , lng: 21.2159, sys: 2},
        { index: 12, name: '51', lat: 44.644 , lng: 21.219, sys: 2},
        { index: 13, name: '52', lat: 44.6443 , lng: 21.2223, sys: 2},
        { index: 14, name: '53', lat: 44.6445 , lng: 21.2254, sys: 2},
        { index: 15, name: '54', lat: 44.6448 , lng: 21.2286, sys: 2},
        { index: 16, name: '55', lat: 44.6451 , lng: 21.2319, sys: 2},
        { index: 17, name: '56', lat: 44.6454 , lng: 21.2352, sys: 2},
        { index: 18, name: '57', lat: 44.6457 , lng: 21.2385, sys: 2},
        { index: 19, name: '58', lat: 44.646 , lng: 21.2417, sys: 2},
        { index: 20, name: '59', lat: 44.6463 , lng: 21.2451, sys: 2},
        { index: 21, name: '60', lat: 44.6465 , lng: 21.2485, sys: 2},
        { index: 22, name: '61', lat: 44.6468 , lng: 21.251, sys: 2},
        { index: 23, name: '62', lat: 44.6454 , lng: 21.2533, sys: 2},
        { index: 24, name: '63', lat: 44.6441 , lng: 21.2553, sys: 2},
        { index: 25, name: '64', lat: 44.6428 , lng: 21.2573, sys: 2},
        { index: 26, name: '65', lat: 44.6406 , lng: 21.2583, sys: 2},
        { index: 27, name: '66', lat: 44.6383 , lng: 21.2592, sys: 2},
        { index: 28, name: '67', lat: 44.6362 , lng: 21.2601, sys: 2},
        { index: 29, name: '68', lat: 44.634 , lng: 21.261, sys: 2},
        { index: 30, name: '69', lat: 44.6317 , lng: 21.2619, sys: 2},
        { index: 31, name: '70', lat: 44.6294 , lng: 21.2628, sys: 2},
        { index: 32, name: '71', lat: 44.6272 , lng: 21.2637, sys: 2},
        { index: 33, name: '72', lat: 44.625 , lng: 21.2652, sys: 2},
        { index: 34, name: '73', lat: 44.623 , lng: 21.2665, sys: 2},
        { index: 35, name: '74', lat: 44.6207 , lng: 21.268, sys: 2},
        { index: 36, name: '75', lat: 44.6188 , lng: 21.2693, sys: 2},
        { index: 37, name: '76', lat: 44.6167 , lng: 21.2706, sys: 2},
        { index: 38, name: '77', lat: 44.6147 , lng: 21.2719, sys: 2},
        { index: 39, name: '78', lat: 44.6125 , lng: 21.2719, sys: 2},
        { index: 40, name: '79', lat: 44.6102 , lng: 21.2719, sys: 2},
        { index: 41, name: '80', lat: 44.608 , lng: 21.2719, sys: 2},
        { index: 42, name: '81', lat: 44.606 , lng: 21.2719, sys: 2},
        { index: 43, name: '82', lat: 44.6038 , lng: 21.2719, sys: 2},
        { index: 44, name: '83', lat: 44.6018 , lng: 21.2729, sys: 2},
        { index: 45, name: '84', lat: 44.5998 , lng: 21.2739, sys: 2},
        { index: 46, name: '85', lat: 44.5975 , lng: 21.275, sys: 2},
        { index: 47, name: '86', lat: 44.5954 , lng: 21.2761, sys: 2},
        { index: 48, name: '87', lat: 44.5932 , lng: 21.2772, sys: 2},
        { index: 49, name: '88', lat: 44.591 , lng: 21.2783, sys: 2},
        { index: 50, name: '89', lat: 44.5889 , lng: 21.2793, sys: 2},
        { index: 51, name: '90', lat: 44.5869 , lng: 21.2803, sys: 2},
        { index: 52, name: '91', lat: 44.5849 , lng: 21.282, sys: 2},
        { index: 53, name: '92', lat: 44.5828 , lng: 21.2837, sys: 2},
        { index: 54, name: '93', lat: 44.5809 , lng: 21.2853, sys: 2},
        { index: 55, name: '94', lat: 44.5789 , lng: 21.2869, sys: 2},
        { index: 56, name: '95', lat: 44.5769 , lng: 21.2885, sys: 2},
        { index: 57, name: '96', lat: 44.575 , lng: 21.2901, sys: 2},
        { index: 58, name: '97', lat: 44.5731 , lng: 21.2917, sys: 2},
        { index: 59, name: '98', lat: 44.5711 , lng: 21.2933, sys: 2},
        { index: 60, name: '99', lat: 44.5692 , lng: 21.2949, sys: 2},
        { index: 61, name: '100', lat: 44.5669 , lng: 21.2963, sys: 2},
        { index: 62, name: '101', lat: 44.5647 , lng: 21.2978, sys: 2},
        { index: 63, name: '102', lat: 44.5625 , lng: 21.2992, sys: 2},
        { index: 64, name: '103', lat: 44.5602 , lng: 21.3006, sys: 2},
        { index: 65, name: '104', lat: 44.5585 , lng: 21.3017, sys: 2},
        { index: 66, name: '105', lat: 44.5562 , lng: 21.3032, sys: 2},
        { index: 67, name: '106', lat: 44.554 , lng: 21.3046, sys: 2},
        { index: 68, name: '107', lat: 44.5518 , lng: 21.306, sys: 2},
        { index: 69, name: '108', lat: 44.5496 , lng: 21.3074, sys: 2},
        { index: 70, name: '109', lat: 44.5474 , lng: 21.3089, sys: 2},
        { index: 71, name: '110', lat: 44.5452 , lng: 21.3103, sys: 2},
        { index: 72, name: '111', lat: 44.543 , lng: 21.3118, sys: 2},
        { index: 73, name: '112', lat: 44.5408 , lng: 21.3133, sys: 2},
        { index: 74, name: '113', lat: 44.5386 , lng: 21.3148, sys: 2},
        { index: 75, name: '114', lat: 44.5363 , lng: 21.3163, sys: 2},
        { index: 76, name: '115', lat: 44.5341 , lng: 21.3178, sys: 2},
        { index: 77, name: '116', lat: 44.532 , lng: 21.3192, sys: 2},
        { index: 78, name: '117', lat: 44.5299 , lng: 21.3201, sys: 2},
        { index: 79, name: '118', lat: 44.5277 , lng: 21.321, sys: 2},
        { index: 80, name: '119', lat: 44.5255 , lng: 21.3219, sys: 2},
        { index: 81, name: '120', lat: 44.5232 , lng: 21.3229, sys: 2},
        { index: 82, name: '121', lat: 44.5209 , lng: 21.3239, sys: 2},
        { index: 83, name: '122', lat: 44.5185 , lng: 21.3249, sys: 2},
        { index: 84, name: '123', lat: 44.5164 , lng: 21.3258, sys: 2},
        { index: 85, name: '124', lat: 44.5142 , lng: 21.3267, sys: 2},
        { index: 86, name: '125', lat: 44.5119 , lng: 21.3276, sys: 2},
        { index: 87, name: '126', lat: 44.5097 , lng: 21.3286, sys: 2},
        { index: 88, name: '127', lat: 44.5075 , lng: 21.329, sys: 2},
        { index: 89, name: '128', lat: 44.5052 , lng: 21.3296, sys: 2},
        { index: 90, name: '129', lat: 44.5028 , lng: 21.3301, sys: 2},
        { index: 91, name: '130', lat: 44.5005 , lng: 21.3306, sys: 2},
        { index: 92, name: '131', lat: 44.4983 , lng: 21.3311, sys: 2},
        { index: 93, name: '132', lat: 44.496 , lng: 21.3316, sys: 2},
        { index: 94, name: '133', lat: 44.4937 , lng: 21.3321, sys: 2},
        { index: 95, name: '134', lat: 44.4914 , lng: 21.3327, sys: 2},
        { index: 96, name: '135', lat: 44.4892 , lng: 21.3332, sys: 2},
        { index: 97, name: '136', lat: 44.4869 , lng: 21.3337, sys: 2},
        { index: 98, name: '137', lat: 44.4847 , lng: 21.3342, sys: 2},
        { index: 99, name: '138', lat: 44.4823 , lng: 21.3349, sys: 2},
        { index: 100, name: '139', lat: 44.4801 , lng: 21.3356, sys: 2},
        { index: 101, name: '140', lat: 44.4778 , lng: 21.3363, sys: 2},
        { index: 102, name: '141', lat: 44.4755 , lng: 21.337, sys: 2},
        { index: 103, name: '142', lat: 44.4733 , lng: 21.3377, sys: 2},
        { index: 104, name: '143', lat: 44.4713 , lng: 21.3383, sys: 2},
        { index: 105, name: '144', lat: 44.4692 , lng: 21.339, sys: 2},
        { index: 106, name: '145', lat: 44.4671 , lng: 21.3393, sys: 2},
        { index: 107, name: '146', lat: 44.465 , lng: 21.3396, sys: 2},
        { index: 108, name: '147', lat: 44.4629 , lng: 21.3399, sys: 2},
        { index: 109, name: '148', lat: 44.4607 , lng: 21.3402, sys: 2},
        { index: 110, name: '149', lat: 44.4587 , lng: 21.3405, sys: 2},
        { index: 111, name: '150', lat: 44.4565 , lng: 21.3408, sys: 2},
        { index: 112, name: '151', lat: 44.4543 , lng: 21.3411, sys: 2},
        { index: 113, name: '152', lat: 44.4518 , lng: 21.3414, sys: 2},
        { index: 114, name: '153', lat: 44.4499 , lng: 21.343, sys: 2},
        { index: 115, name: '154', lat: 44.448 , lng: 21.3446, sys: 2},
        { index: 116, name: '155', lat: 44.4462 , lng: 21.346, sys: 2},
        { index: 117, name: '156', lat: 44.4444 , lng: 21.3475, sys: 2},
        { index: 118, name: '157', lat: 44.4426 , lng: 21.3489, sys: 2},
        { index: 119, name: '158', lat: 44.4407 , lng: 21.3504, sys: 2},
        { index: 120, name: '159', lat: 44.4387 , lng: 21.352, sys: 2},
        { index: 121, name: '160', lat: 44.4367 , lng: 21.3537, sys: 2},
        { index: 122, name: '161', lat: 44.4346 , lng: 21.3554, sys: 2},
        { index: 123, name: '162', lat: 44.4328 , lng: 21.3554, sys: 2},
        { index: 124, name: '163', lat: 44.4309 , lng: 21.3554, sys: 2},
        { index: 125, name: '164', lat: 44.4289 , lng: 21.3555, sys: 2},
        { index: 126, name: '165', lat: 44.4273 , lng: 21.358, sys: 2},
        { index: 127, name: '166', lat: 44.4257 , lng: 21.3606, sys: 2},
        { index: 128, name: '167', lat: 44.424 , lng: 21.3631, sys: 2},
        { index: 129, name: '168', lat: 44.4224 , lng: 21.3657, sys: 2},
        { index: 130, name: '169', lat: 44.4208 , lng: 21.3682, sys: 2},
        { index: 131, name: '170', lat: 44.4192 , lng: 21.3707, sys: 2},
        { index: 132, name: '171', lat: 44.4176 , lng: 21.3732, sys: 2},
        { index: 133, name: '172', lat: 44.4159 , lng: 21.3758, sys: 2},
        { index: 134, name: '173', lat: 44.4143 , lng: 21.3784, sys: 2},
        { index: 135, name: '174', lat: 44.4124 , lng: 21.3807, sys: 2},
        { index: 136, name: '175', lat: 44.4106 , lng: 21.3831, sys: 2},
        { index: 137, name: '176', lat: 44.4088 , lng: 21.3855, sys: 2},
        { index: 138, name: '177', lat: 44.407 , lng: 21.3878, sys: 2},
        { index: 139, name: '178', lat: 44.4051 , lng: 21.3901, sys: 2},
        { index: 140, name: '179', lat: 44.4033 , lng: 21.3925, sys: 2},
        { index: 141, name: '180', lat: 44.4015 , lng: 21.3947, sys: 2},
        { index: 142, name: '181', lat: 44.3998 , lng: 21.397, sys: 2},
        { index: 143, name: '182', lat: 44.398 , lng: 21.3993, sys: 2},
        { index: 144, name: '183', lat: 44.3963 , lng: 21.4015, sys: 2},
        { index: 145, name: 'P-05', lat: 44.3958 , lng: 21.402, sys: 1, portal: true}
    ],
    rasponi: [
        { name: 'P-05 - 41', position: [{ lat: 44.6539 , lng: 21.1897 }, { lat: 44.6534 , lng: 21.1905 }] },
        { name: '41 - 42', position: [{ lat: 44.6534 , lng: 21.1905 }, { lat: 44.6522 , lng: 21.1934 }] },
        { name: '42 - 43', position: [{ lat: 44.6522 , lng: 21.1934 }, { lat: 44.651 , lng: 21.1961 }] },
        { name: '43 - 44', position: [{ lat: 44.651 , lng: 21.1961 }, { lat: 44.65 , lng: 21.1983 }] },
        { name: '44 - 45', position: [{ lat: 44.65 , lng: 21.1983 }, { lat: 44.6491 , lng: 21.2002 }] },
        { name: '45 - 46', position: [{ lat: 44.6491 , lng: 21.2002 }, { lat: 44.6481 , lng: 21.2032 }] },
        { name: '46 - 47', position: [{ lat: 44.6481 , lng: 21.2032 }, { lat: 44.647 , lng: 21.2064 }] },
        { name: '47 - 48', position: [{ lat: 44.647 , lng: 21.2064 }, { lat: 44.6459 , lng: 21.2096 }] },
        { name: '48 - 49', position: [{ lat: 44.6459 , lng: 21.2096 }, { lat: 44.6448 , lng: 21.2128 }] },
        { name: '49 - 50', position: [{ lat: 44.6448 , lng: 21.2128 }, { lat: 44.6437 , lng: 21.2159 }] },
        { name: '50 - 51', position: [{ lat: 44.6437 , lng: 21.2159 }, { lat: 44.644 , lng: 21.219 }] },
        { name: '51 - 52', position: [{ lat: 44.644 , lng: 21.219 }, { lat: 44.6443 , lng: 21.2223 }] },
        { name: '52 - 53', position: [{ lat: 44.6443 , lng: 21.2223 }, { lat: 44.6445 , lng: 21.2254 }] },
        { name: '53 - 54', position: [{ lat: 44.6445 , lng: 21.2254 }, { lat: 44.6448 , lng: 21.2286 }] },
        { name: '54 - 55', position: [{ lat: 44.6448 , lng: 21.2286 }, { lat: 44.6451 , lng: 21.2319 }] },
        { name: '55 - 56', position: [{ lat: 44.6451 , lng: 21.2319 }, { lat: 44.6454 , lng: 21.2352 }] },
        { name: '56 - 57', position: [{ lat: 44.6454 , lng: 21.2352 }, { lat: 44.6457 , lng: 21.2385 }] },
        { name: '57 - 58', position: [{ lat: 44.6457 , lng: 21.2385 }, { lat: 44.646 , lng: 21.2417 }] },
        { name: '58 - 59', position: [{ lat: 44.646 , lng: 21.2417 }, { lat: 44.6463 , lng: 21.2451 }] },
        { name: '59 - 60', position: [{ lat: 44.6463 , lng: 21.2451 }, { lat: 44.6465 , lng: 21.2485 }] },
        { name: '60 - 61', position: [{ lat: 44.6465 , lng: 21.2485 }, { lat: 44.6468 , lng: 21.251 }] },
        { name: '61 - 62', position: [{ lat: 44.6468 , lng: 21.251 }, { lat: 44.6454 , lng: 21.2533 }] },
        { name: '62 - 63', position: [{ lat: 44.6454 , lng: 21.2533 }, { lat: 44.6441 , lng: 21.2553 }] },
        { name: '63 - 64', position: [{ lat: 44.6441 , lng: 21.2553 }, { lat: 44.6428 , lng: 21.2573 }] },
        { name: '64 - 65', position: [{ lat: 44.6428 , lng: 21.2573 }, { lat: 44.6406 , lng: 21.2583 }] },
        { name: '65 - 66', position: [{ lat: 44.6406 , lng: 21.2583 }, { lat: 44.6383 , lng: 21.2592 }] },
        { name: '66 - 67', position: [{ lat: 44.6383 , lng: 21.2592 }, { lat: 44.6362 , lng: 21.2601 }] },
        { name: '67 - 68', position: [{ lat: 44.6362 , lng: 21.2601 }, { lat: 44.634 , lng: 21.261 }] },
        { name: '68 - 69', position: [{ lat: 44.634 , lng: 21.261 }, { lat: 44.6317 , lng: 21.2619 }] },
        { name: '69 - 70', position: [{ lat: 44.6317 , lng: 21.2619 }, { lat: 44.6294 , lng: 21.2628 }] },
        { name: '70 - 71', position: [{ lat: 44.6294 , lng: 21.2628 }, { lat: 44.6272 , lng: 21.2637 }] },
        { name: '71 - 72', position: [{ lat: 44.6272 , lng: 21.2637 }, { lat: 44.625 , lng: 21.2652 }] },
        { name: '72 - 73', position: [{ lat: 44.625 , lng: 21.2652 }, { lat: 44.623 , lng: 21.2665 }] },
        { name: '73 - 74', position: [{ lat: 44.623 , lng: 21.2665 }, { lat: 44.6207 , lng: 21.268 }] },
        { name: '74 - 75', position: [{ lat: 44.6207 , lng: 21.268 }, { lat: 44.6188 , lng: 21.2693 }] },
        { name: '75 - 76', position: [{ lat: 44.6188 , lng: 21.2693 }, { lat: 44.6167 , lng: 21.2706 }] },
        { name: '76 - 77', position: [{ lat: 44.6167 , lng: 21.2706 }, { lat: 44.6147 , lng: 21.2719 }] },
        { name: '77 - 78', position: [{ lat: 44.6147 , lng: 21.2719 }, { lat: 44.6125 , lng: 21.2719 }] },
        { name: '78 - 79', position: [{ lat: 44.6125 , lng: 21.2719 }, { lat: 44.6102 , lng: 21.2719 }] },
        { name: '79 - 80', position: [{ lat: 44.6102 , lng: 21.2719 }, { lat: 44.608 , lng: 21.2719 }] },
        { name: '80 - 81', position: [{ lat: 44.608 , lng: 21.2719 }, { lat: 44.606 , lng: 21.2719 }] },
        { name: '81 - 82', position: [{ lat: 44.606 , lng: 21.2719 }, { lat: 44.6038 , lng: 21.2719 }] },
        { name: '82 - 83', position: [{ lat: 44.6038 , lng: 21.2719 }, { lat: 44.6018 , lng: 21.2729 }] },
        { name: '83 - 84', position: [{ lat: 44.6018 , lng: 21.2729 }, { lat: 44.5998 , lng: 21.2739 }] },
        { name: '84 - 85', position: [{ lat: 44.5998 , lng: 21.2739 }, { lat: 44.5975 , lng: 21.275 }] },
        { name: '85 - 86', position: [{ lat: 44.5975 , lng: 21.275 }, { lat: 44.5954 , lng: 21.2761 }] },
        { name: '86 - 87', position: [{ lat: 44.5954 , lng: 21.2761 }, { lat: 44.5932 , lng: 21.2772 }] },
        { name: '87 - 88', position: [{ lat: 44.5932 , lng: 21.2772 }, { lat: 44.591 , lng: 21.2783 }] },
        { name: '88 - 89', position: [{ lat: 44.591 , lng: 21.2783 }, { lat: 44.5889 , lng: 21.2793 }] },
        { name: '89 - 90', position: [{ lat: 44.5889 , lng: 21.2793 }, { lat: 44.5869 , lng: 21.2803 }] },
        { name: '90 - 91', position: [{ lat: 44.5869 , lng: 21.2803 }, { lat: 44.5849 , lng: 21.282 }] },
        { name: '91 - 92', position: [{ lat: 44.5849 , lng: 21.282 }, { lat: 44.5828 , lng: 21.2837 }] },
        { name: '92 - 93', position: [{ lat: 44.5828 , lng: 21.2837 }, { lat: 44.5809 , lng: 21.2853 }] },
        { name: '93 - 94', position: [{ lat: 44.5809 , lng: 21.2853 }, { lat: 44.5789 , lng: 21.2869 }] },
        { name: '94 - 95', position: [{ lat: 44.5789 , lng: 21.2869 }, { lat: 44.5769 , lng: 21.2885 }] },
        { name: '95 - 96', position: [{ lat: 44.5769 , lng: 21.2885 }, { lat: 44.575 , lng: 21.2901 }] },
        { name: '96 - 97', position: [{ lat: 44.575 , lng: 21.2901 }, { lat: 44.5731 , lng: 21.2917 }] },
        { name: '97 - 98', position: [{ lat: 44.5731 , lng: 21.2917 }, { lat: 44.5711 , lng: 21.2933 }] },
        { name: '98 - 99', position: [{ lat: 44.5711 , lng: 21.2933 }, { lat: 44.5692 , lng: 21.2949 }] },
        { name: '99 - 100', position: [{ lat: 44.5692 , lng: 21.2949 }, { lat: 44.5669 , lng: 21.2963 }] },
        { name: '100 - 101', position: [{ lat: 44.5669 , lng: 21.2963 }, { lat: 44.5647 , lng: 21.2978 }] },
        { name: '101 - 102', position: [{ lat: 44.5647 , lng: 21.2978 }, { lat: 44.5625 , lng: 21.2992 }] },
        { name: '102 - 103', position: [{ lat: 44.5625 , lng: 21.2992 }, { lat: 44.5602 , lng: 21.3006 }] },
        { name: '103 - 104', position: [{ lat: 44.5602 , lng: 21.3006 }, { lat: 44.5585 , lng: 21.3017 }] },
        { name: '104 - 105', position: [{ lat: 44.5585 , lng: 21.3017 }, { lat: 44.5562 , lng: 21.3032 }] },
        { name: '105 - 106', position: [{ lat: 44.5562 , lng: 21.3032 }, { lat: 44.554 , lng: 21.3046 }] },
        { name: '106 - 107', position: [{ lat: 44.554 , lng: 21.3046 }, { lat: 44.5518 , lng: 21.306 }] },
        { name: '107 - 108', position: [{ lat: 44.5518 , lng: 21.306 }, { lat: 44.5496 , lng: 21.3074 }] },
        { name: '108 - 109', position: [{ lat: 44.5496 , lng: 21.3074 }, { lat: 44.5474 , lng: 21.3089 }] },
        { name: '109 - 110', position: [{ lat: 44.5474 , lng: 21.3089 }, { lat: 44.5452 , lng: 21.3103 }] },
        { name: '110 - 111', position: [{ lat: 44.5452 , lng: 21.3103 }, { lat: 44.543 , lng: 21.3118 }] },
        { name: '111 - 112', position: [{ lat: 44.543 , lng: 21.3118 }, { lat: 44.5408 , lng: 21.3133 }] },
        { name: '112 - 113', position: [{ lat: 44.5408 , lng: 21.3133 }, { lat: 44.5386 , lng: 21.3148 }] },
        { name: '113 - 114', position: [{ lat: 44.5386 , lng: 21.3148 }, { lat: 44.5363 , lng: 21.3163 }] },
        { name: '114 - 115', position: [{ lat: 44.5363 , lng: 21.3163 }, { lat: 44.5341 , lng: 21.3178 }] },
        { name: '115 - 116', position: [{ lat: 44.5341 , lng: 21.3178 }, { lat: 44.532 , lng: 21.3192 }] },
        { name: '116 - 117', position: [{ lat: 44.532 , lng: 21.3192 }, { lat: 44.5299 , lng: 21.3201 }] },
        { name: '117 - 118', position: [{ lat: 44.5299 , lng: 21.3201 }, { lat: 44.5277 , lng: 21.321 }] },
        { name: '118 - 119', position: [{ lat: 44.5277 , lng: 21.321 }, { lat: 44.5255 , lng: 21.3219 }] },
        { name: '119 - 120', position: [{ lat: 44.5255 , lng: 21.3219 }, { lat: 44.5232 , lng: 21.3229 }] },
        { name: '120 - 121', position: [{ lat: 44.5232 , lng: 21.3229 }, { lat: 44.5209 , lng: 21.3239 }] },
        { name: '121 - 122', position: [{ lat: 44.5209 , lng: 21.3239 }, { lat: 44.5185 , lng: 21.3249 }] },
        { name: '122 - 123', position: [{ lat: 44.5185 , lng: 21.3249 }, { lat: 44.5164 , lng: 21.3258 }] },
        { name: '123 - 124', position: [{ lat: 44.5164 , lng: 21.3258 }, { lat: 44.5142 , lng: 21.3267 }] },
        { name: '124 - 125', position: [{ lat: 44.5142 , lng: 21.3267 }, { lat: 44.5119 , lng: 21.3276 }] },
        { name: '125 - 126', position: [{ lat: 44.5119 , lng: 21.3276 }, { lat: 44.5097 , lng: 21.3286 }] },
        { name: '126 - 127', position: [{ lat: 44.5097 , lng: 21.3286 }, { lat: 44.5075 , lng: 21.329 }] },
        { name: '127 - 128', position: [{ lat: 44.5075 , lng: 21.329 }, { lat: 44.5052 , lng: 21.3296 }] },
        { name: '128 - 129', position: [{ lat: 44.5052 , lng: 21.3296 }, { lat: 44.5028 , lng: 21.3301 }] },
        { name: '129 - 130', position: [{ lat: 44.5028 , lng: 21.3301 }, { lat: 44.5005 , lng: 21.3306 }] },
        { name: '130 - 131', position: [{ lat: 44.5005 , lng: 21.3306 }, { lat: 44.4983 , lng: 21.3311 }] },
        { name: '131 - 132', position: [{ lat: 44.4983 , lng: 21.3311 }, { lat: 44.496 , lng: 21.3316 }] },
        { name: '132 - 133', position: [{ lat: 44.496 , lng: 21.3316 }, { lat: 44.4937 , lng: 21.3321 }] },
        { name: '133 - 134', position: [{ lat: 44.4937 , lng: 21.3321 }, { lat: 44.4914 , lng: 21.3327 }] },
        { name: '134 - 135', position: [{ lat: 44.4914 , lng: 21.3327 }, { lat: 44.4892 , lng: 21.3332 }] },
        { name: '135 - 136', position: [{ lat: 44.4892 , lng: 21.3332 }, { lat: 44.4869 , lng: 21.3337 }] },
        { name: '136 - 137', position: [{ lat: 44.4869 , lng: 21.3337 }, { lat: 44.4847 , lng: 21.3342 }] },
        { name: '137 - 138', position: [{ lat: 44.4847 , lng: 21.3342 }, { lat: 44.4823 , lng: 21.3349 }] },
        { name: '138 - 139', position: [{ lat: 44.4823 , lng: 21.3349 }, { lat: 44.4801 , lng: 21.3356 }] },
        { name: '139 - 140', position: [{ lat: 44.4801 , lng: 21.3356 }, { lat: 44.4778 , lng: 21.3363 }] },
        { name: '140 - 141', position: [{ lat: 44.4778 , lng: 21.3363 }, { lat: 44.4755 , lng: 21.337 }] },
        { name: '141 - 142', position: [{ lat: 44.4755 , lng: 21.337 }, { lat: 44.4733 , lng: 21.3377 }] },
        { name: '142 - 143', position: [{ lat: 44.4733 , lng: 21.3377 }, { lat: 44.4713 , lng: 21.3383 }] },
        { name: '143 - 144', position: [{ lat: 44.4713 , lng: 21.3383 }, { lat: 44.4692 , lng: 21.339 }] },
        { name: '144 - 145', position: [{ lat: 44.4692 , lng: 21.339 }, { lat: 44.4671 , lng: 21.3393 }] },
        { name: '145 - 146', position: [{ lat: 44.4671 , lng: 21.3393 }, { lat: 44.465 , lng: 21.3396 }] },
        { name: '146 - 147', position: [{ lat: 44.465 , lng: 21.3396 }, { lat: 44.4629 , lng: 21.3399 }] },
        { name: '147 - 148', position: [{ lat: 44.4629 , lng: 21.3399 }, { lat: 44.4607 , lng: 21.3402 }] },
        { name: '148 - 149', position: [{ lat: 44.4607 , lng: 21.3402 }, { lat: 44.4587 , lng: 21.3405 }] },
        { name: '149 - 150', position: [{ lat: 44.4587 , lng: 21.3405 }, { lat: 44.4565 , lng: 21.3408 }] },
        { name: '150 - 151', position: [{ lat: 44.4565 , lng: 21.3408 }, { lat: 44.4543 , lng: 21.3411 }] },
        { name: '151 - 152', position: [{ lat: 44.4543 , lng: 21.3411 }, { lat: 44.4518 , lng: 21.3414 }] },
        { name: '152 - 153', position: [{ lat: 44.4518 , lng: 21.3414 }, { lat: 44.4499 , lng: 21.343 }] },
        { name: '153 - 154', position: [{ lat: 44.4499 , lng: 21.343 }, { lat: 44.448 , lng: 21.3446 }] },
        { name: '154 - 155', position: [{ lat: 44.448 , lng: 21.3446 }, { lat: 44.4462 , lng: 21.346 }] },
        { name: '155 - 156', position: [{ lat: 44.4462 , lng: 21.346 }, { lat: 44.4444 , lng: 21.3475 }] },
        { name: '156 - 157', position: [{ lat: 44.4444 , lng: 21.3475 }, { lat: 44.4426 , lng: 21.3489 }] },
        { name: '157 - 158', position: [{ lat: 44.4426 , lng: 21.3489 }, { lat: 44.4407 , lng: 21.3504 }] },
        { name: '158 - 159', position: [{ lat: 44.4407 , lng: 21.3504 }, { lat: 44.4387 , lng: 21.352 }] },
        { name: '159 - 160', position: [{ lat: 44.4387 , lng: 21.352 }, { lat: 44.4367 , lng: 21.3537 }] },
        { name: '160 - 161', position: [{ lat: 44.4367 , lng: 21.3537 }, { lat: 44.4346 , lng: 21.3554 }] },
        { name: '161 - 162', position: [{ lat: 44.4346 , lng: 21.3554 }, { lat: 44.4328 , lng: 21.3554 }] },
        { name: '162 - 163', position: [{ lat: 44.4328 , lng: 21.3554 }, { lat: 44.4309 , lng: 21.3554 }] },
        { name: '163 - 164', position: [{ lat: 44.4309 , lng: 21.3554 }, { lat: 44.4289 , lng: 21.3555 }] },
        { name: '164 - 165', position: [{ lat: 44.4289 , lng: 21.3555 }, { lat: 44.4273 , lng: 21.358 }] },
        { name: '165 - 166', position: [{ lat: 44.4273 , lng: 21.358 }, { lat: 44.4257 , lng: 21.3606 }] },
        { name: '166 - 167', position: [{ lat: 44.4257 , lng: 21.3606 }, { lat: 44.424 , lng: 21.3631 }] },
        { name: '167 - 168', position: [{ lat: 44.424 , lng: 21.3631 }, { lat: 44.4224 , lng: 21.3657 }] },
        { name: '168 - 169', position: [{ lat: 44.4224 , lng: 21.3657 }, { lat: 44.4208 , lng: 21.3682 }] },
        { name: '169 - 170', position: [{ lat: 44.4208 , lng: 21.3682 }, { lat: 44.4192 , lng: 21.3707 }] },
        { name: '170 - 171', position: [{ lat: 44.4192 , lng: 21.3707 }, { lat: 44.4176 , lng: 21.3732 }] },
        { name: '171 - 172', position: [{ lat: 44.4176 , lng: 21.3732 }, { lat: 44.4159 , lng: 21.3758 }] },
        { name: '172 - 173', position: [{ lat: 44.4159 , lng: 21.3758 }, { lat: 44.4143 , lng: 21.3784 }] },
        { name: '173 - 174', position: [{ lat: 44.4143 , lng: 21.3784 }, { lat: 44.4124 , lng: 21.3807 }] },
        { name: '174 - 175', position: [{ lat: 44.4124 , lng: 21.3807 }, { lat: 44.4106 , lng: 21.3831 }] },
        { name: '175 - 176', position: [{ lat: 44.4106 , lng: 21.3831 }, { lat: 44.4088 , lng: 21.3855 }] },
        { name: '176 - 177', position: [{ lat: 44.4088 , lng: 21.3855 }, { lat: 44.407 , lng: 21.3878 }] },
        { name: '177 - 178', position: [{ lat: 44.407 , lng: 21.3878 }, { lat: 44.4051 , lng: 21.3901 }] },
        { name: '178 - 179', position: [{ lat: 44.4051 , lng: 21.3901 }, { lat: 44.4033 , lng: 21.3925 }] },
        { name: '179 - 180', position: [{ lat: 44.4033 , lng: 21.3925 }, { lat: 44.4015 , lng: 21.3947 }] },
        { name: '180 - 181', position: [{ lat: 44.4015 , lng: 21.3947 }, { lat: 44.3998 , lng: 21.397 }] },
        { name: '181 - 182', position: [{ lat: 44.3998 , lng: 21.397 }, { lat: 44.398 , lng: 21.3993 }] },
        { name: '182 - 183', position: [{ lat: 44.398 , lng: 21.3993 }, { lat: 44.3963 , lng: 21.4015 }] },
        { name: '183 - P-05', position: [{ lat: 44.3963 , lng: 21.4015 }, { lat: 44.3958 , lng: 21.402 }] }
    ],
    phaseCross: [
        { 
            name: '109 - 110', 
            position:  [{ lat: 44.5474, lng: 21.3089 }, { lat: 44.5452, lng: 21.3103 }], 
            OHLs: ['DV 102A/2', 'DV 102B/2'], 
            phases: [
                { phase: 0, position1: 'Middle', position2: 'Right' }, 
                { phase: 4, position1: 'Left', position2: 'Middle' },
                { phase: 8, position1: 'Right', position2: 'Left' }
            ]
        },
        { 
            name: '173 - 174', 
            position: [{ lat: 44.4143, lng: 21.3784 }, { lat: 44.4124, lng: 21.3807 }], 
            OHLs: ['DV 102A/2', 'DV 102B/2'], 
            phases: [
                { phase: 0, position1: 'Right', position2: 'Left' }, 
                { phase: 4, position1: 'Middle', position2: 'Right' },
                { phase: 8, position1: 'Left', position2: 'Middle' }
            ]
        }
    ]
}



export const OhlSegments = {
    name: 'DV 102B/2 TS POŽAREVAC - TS PETROVAC',
    voltage: '110',
    stanice: [],
    stubovi: [
        { index: 1, name: 'P-05', lat: 44.6539 , lng: 21.1897, sys: 1, portal: true},
        { index: 2, name: '41', lat: 44.6534 , lng: 21.1905, sys: 2},
        { index: 3, name: '42', lat: 44.6522 , lng: 21.1934, sys: 2},
        { index: 4, name: '43', lat: 44.651 , lng: 21.1961, sys: 2},
        { index: 5, name: '44', lat: 44.65 , lng: 21.1983, sys: 2},
        { index: 6, name: '45', lat: 44.6491 , lng: 21.2002, sys: 2},
        { index: 7, name: '46', lat: 44.6481 , lng: 21.2032, sys: 2},
        { index: 8, name: '47', lat: 44.647 , lng: 21.2064, sys: 2},
        { index: 9, name: '48', lat: 44.6459 , lng: 21.2096, sys: 2},
        { index: 10, name: '49', lat: 44.6448 , lng: 21.2128, sys: 2},
        { index: 11, name: '50', lat: 44.6437 , lng: 21.2159, sys: 2},
        { index: 12, name: '51', lat: 44.644 , lng: 21.219, sys: 2},
        { index: 13, name: '52', lat: 44.6443 , lng: 21.2223, sys: 2},
        { index: 14, name: '53', lat: 44.6445 , lng: 21.2254, sys: 2},
        { index: 15, name: '54', lat: 44.6448 , lng: 21.2286, sys: 2},
        { index: 16, name: '55', lat: 44.6451 , lng: 21.2319, sys: 2},
        { index: 17, name: '56', lat: 44.6454 , lng: 21.2352, sys: 2},
        { index: 18, name: '57', lat: 44.6457 , lng: 21.2385, sys: 2},
        { index: 19, name: '58', lat: 44.646 , lng: 21.2417, sys: 2},
        { index: 20, name: '59', lat: 44.6463 , lng: 21.2451, sys: 2},
        { index: 21, name: '60', lat: 44.6465 , lng: 21.2485, sys: 2},
        { index: 22, name: '61', lat: 44.6468 , lng: 21.251, sys: 2},
        { index: 23, name: '62', lat: 44.6454 , lng: 21.2533, sys: 2},
        { index: 24, name: '63', lat: 44.6441 , lng: 21.2553, sys: 2},
        { index: 25, name: '64', lat: 44.6428 , lng: 21.2573, sys: 2},
        { index: 26, name: '65', lat: 44.6406 , lng: 21.2583, sys: 2},
        { index: 27, name: '66', lat: 44.6383 , lng: 21.2592, sys: 2},
        { index: 28, name: '67', lat: 44.6362 , lng: 21.2601, sys: 2},
        { index: 29, name: '68', lat: 44.634 , lng: 21.261, sys: 2},
        { index: 30, name: '69', lat: 44.6317 , lng: 21.2619, sys: 2},
        { index: 31, name: '70', lat: 44.6294 , lng: 21.2628, sys: 2},
        { index: 32, name: '71', lat: 44.6272 , lng: 21.2637, sys: 2},
        { index: 33, name: '72', lat: 44.625 , lng: 21.2652, sys: 2},
        { index: 34, name: '73', lat: 44.623 , lng: 21.2665, sys: 2},
        { index: 35, name: '74', lat: 44.6207 , lng: 21.268, sys: 2},
        { index: 36, name: '75', lat: 44.6188 , lng: 21.2693, sys: 2},
        { index: 37, name: '76', lat: 44.6167 , lng: 21.2706, sys: 2},
        { index: 38, name: '77', lat: 44.6147 , lng: 21.2719, sys: 2},
        { index: 39, name: '78', lat: 44.6125 , lng: 21.2719, sys: 2},
        { index: 40, name: '79', lat: 44.6102 , lng: 21.2719, sys: 2},
        { index: 41, name: '80', lat: 44.608 , lng: 21.2719, sys: 2},
        { index: 42, name: '81', lat: 44.606 , lng: 21.2719, sys: 2},
        { index: 43, name: '82', lat: 44.6038 , lng: 21.2719, sys: 2},
        { index: 44, name: '83', lat: 44.6018 , lng: 21.2729, sys: 2},
        { index: 45, name: '84', lat: 44.5998 , lng: 21.2739, sys: 2},
        { index: 46, name: '85', lat: 44.5975 , lng: 21.275, sys: 2},
        { index: 47, name: '86', lat: 44.5954 , lng: 21.2761, sys: 2},
        { index: 48, name: '87', lat: 44.5932 , lng: 21.2772, sys: 2},
        { index: 49, name: '88', lat: 44.591 , lng: 21.2783, sys: 2},
        { index: 50, name: '89', lat: 44.5889 , lng: 21.2793, sys: 2},
        { index: 51, name: '90', lat: 44.5869 , lng: 21.2803, sys: 2},
        { index: 52, name: '91', lat: 44.5849 , lng: 21.282, sys: 2},
        { index: 53, name: '92', lat: 44.5828 , lng: 21.2837, sys: 2},
        { index: 54, name: '93', lat: 44.5809 , lng: 21.2853, sys: 2},
        { index: 55, name: '94', lat: 44.5789 , lng: 21.2869, sys: 2},
        { index: 56, name: '95', lat: 44.5769 , lng: 21.2885, sys: 2},
        { index: 57, name: '96', lat: 44.575 , lng: 21.2901, sys: 2},
        { index: 58, name: '97', lat: 44.5731 , lng: 21.2917, sys: 2},
        { index: 59, name: '98', lat: 44.5711 , lng: 21.2933, sys: 2},
        { index: 60, name: '99', lat: 44.5692 , lng: 21.2949, sys: 2},
        { index: 61, name: '100', lat: 44.5669 , lng: 21.2963, sys: 2},
        { index: 62, name: '101', lat: 44.5647 , lng: 21.2978, sys: 2},
        { index: 63, name: '102', lat: 44.5625 , lng: 21.2992, sys: 2},
        { index: 64, name: '103', lat: 44.5602 , lng: 21.3006, sys: 2},
        { index: 65, name: '104', lat: 44.5585 , lng: 21.3017, sys: 2},
        { index: 66, name: '105', lat: 44.5562 , lng: 21.3032, sys: 2},
        { index: 67, name: '106', lat: 44.554 , lng: 21.3046, sys: 2},
        { index: 68, name: '107', lat: 44.5518 , lng: 21.306, sys: 2},
        { index: 69, name: '108', lat: 44.5496 , lng: 21.3074, sys: 2},
        { index: 70, name: '109', lat: 44.5474 , lng: 21.3089, sys: 2},
        { index: 71, name: '110', lat: 44.5452 , lng: 21.3103, sys: 2},
        { index: 72, name: '111', lat: 44.543 , lng: 21.3118, sys: 2},
        { index: 73, name: '112', lat: 44.5408 , lng: 21.3133, sys: 2},
        { index: 74, name: '113', lat: 44.5386 , lng: 21.3148, sys: 2},
        { index: 75, name: '114', lat: 44.5363 , lng: 21.3163, sys: 2},
        { index: 76, name: '115', lat: 44.5341 , lng: 21.3178, sys: 2},
        { index: 77, name: '116', lat: 44.532 , lng: 21.3192, sys: 2},
        { index: 78, name: '117', lat: 44.5299 , lng: 21.3201, sys: 2},
        { index: 79, name: '118', lat: 44.5277 , lng: 21.321, sys: 2},
        { index: 80, name: '119', lat: 44.5255 , lng: 21.3219, sys: 2},
        { index: 81, name: '120', lat: 44.5232 , lng: 21.3229, sys: 2},
        { index: 82, name: '121', lat: 44.5209 , lng: 21.3239, sys: 2},
        { index: 83, name: '122', lat: 44.5185 , lng: 21.3249, sys: 2},
        { index: 84, name: '123', lat: 44.5164 , lng: 21.3258, sys: 2},
        { index: 85, name: '124', lat: 44.5142 , lng: 21.3267, sys: 2},
        { index: 86, name: '125', lat: 44.5119 , lng: 21.3276, sys: 2},
        { index: 87, name: '126', lat: 44.5097 , lng: 21.3286, sys: 2},
        { index: 88, name: '127', lat: 44.5075 , lng: 21.329, sys: 2},
        { index: 89, name: '128', lat: 44.5052 , lng: 21.3296, sys: 2},
        { index: 90, name: '129', lat: 44.5028 , lng: 21.3301, sys: 2},
        { index: 91, name: '130', lat: 44.5005 , lng: 21.3306, sys: 2},
        { index: 92, name: '131', lat: 44.4983 , lng: 21.3311, sys: 2},
        { index: 93, name: '132', lat: 44.496 , lng: 21.3316, sys: 2},
        { index: 94, name: '133', lat: 44.4937 , lng: 21.3321, sys: 2},
        { index: 95, name: '134', lat: 44.4914 , lng: 21.3327, sys: 2},
        { index: 96, name: '135', lat: 44.4892 , lng: 21.3332, sys: 2},
        { index: 97, name: '136', lat: 44.4869 , lng: 21.3337, sys: 2},
        { index: 98, name: '137', lat: 44.4847 , lng: 21.3342, sys: 2},
        { index: 99, name: '138', lat: 44.4823 , lng: 21.3349, sys: 2},
        { index: 100, name: '139', lat: 44.4801 , lng: 21.3356, sys: 2},
        { index: 101, name: '140', lat: 44.4778 , lng: 21.3363, sys: 2},
        { index: 102, name: '141', lat: 44.4755 , lng: 21.337, sys: 2},
        { index: 103, name: '142', lat: 44.4733 , lng: 21.3377, sys: 2},
        { index: 104, name: '143', lat: 44.4713 , lng: 21.3383, sys: 2},
        { index: 105, name: '144', lat: 44.4692 , lng: 21.339, sys: 2},
        { index: 106, name: '145', lat: 44.4671 , lng: 21.3393, sys: 2},
        { index: 107, name: '146', lat: 44.465 , lng: 21.3396, sys: 2},
        { index: 108, name: '147', lat: 44.4629 , lng: 21.3399, sys: 2},
        { index: 109, name: '148', lat: 44.4607 , lng: 21.3402, sys: 2},
        { index: 110, name: '149', lat: 44.4587 , lng: 21.3405, sys: 2},
        { index: 111, name: '150', lat: 44.4565 , lng: 21.3408, sys: 2},
        { index: 112, name: '151', lat: 44.4543 , lng: 21.3411, sys: 2},
        { index: 113, name: '152', lat: 44.4518 , lng: 21.3414, sys: 2},
        { index: 114, name: '153', lat: 44.4499 , lng: 21.343, sys: 2},
        { index: 115, name: '154', lat: 44.448 , lng: 21.3446, sys: 2},
        { index: 116, name: '155', lat: 44.4462 , lng: 21.346, sys: 2},
        { index: 117, name: '156', lat: 44.4444 , lng: 21.3475, sys: 2},
        { index: 118, name: '157', lat: 44.4426 , lng: 21.3489, sys: 2},
        { index: 119, name: '158', lat: 44.4407 , lng: 21.3504, sys: 2},
        { index: 120, name: '159', lat: 44.4387 , lng: 21.352, sys: 2},
        { index: 121, name: '160', lat: 44.4367 , lng: 21.3537, sys: 2},
        { index: 122, name: '161', lat: 44.4346 , lng: 21.3554, sys: 2},
        { index: 123, name: '162', lat: 44.4328 , lng: 21.3554, sys: 2},
        { index: 124, name: '163', lat: 44.4309 , lng: 21.3554, sys: 2},
        { index: 125, name: '164', lat: 44.4289 , lng: 21.3555, sys: 2},
        { index: 126, name: '165', lat: 44.4273 , lng: 21.358, sys: 2},
        { index: 127, name: '166', lat: 44.4257 , lng: 21.3606, sys: 2},
        { index: 128, name: '167', lat: 44.424 , lng: 21.3631, sys: 2},
        { index: 129, name: '168', lat: 44.4224 , lng: 21.3657, sys: 2},
        { index: 130, name: '169', lat: 44.4208 , lng: 21.3682, sys: 2},
        { index: 131, name: '170', lat: 44.4192 , lng: 21.3707, sys: 2},
        { index: 132, name: '171', lat: 44.4176 , lng: 21.3732, sys: 2},
        { index: 133, name: '172', lat: 44.4159 , lng: 21.3758, sys: 2},
        { index: 134, name: '173', lat: 44.4143 , lng: 21.3784, sys: 2},
        { index: 135, name: '174', lat: 44.4124 , lng: 21.3807, sys: 2},
        { index: 136, name: '175', lat: 44.4106 , lng: 21.3831, sys: 2},
        { index: 137, name: '176', lat: 44.4088 , lng: 21.3855, sys: 2},
        { index: 138, name: '177', lat: 44.407 , lng: 21.3878, sys: 2},
        { index: 139, name: '178', lat: 44.4051 , lng: 21.3901, sys: 2},
        { index: 140, name: '179', lat: 44.4033 , lng: 21.3925, sys: 2},
        { index: 141, name: '180', lat: 44.4015 , lng: 21.3947, sys: 2},
        { index: 142, name: '181', lat: 44.3998 , lng: 21.397, sys: 2},
        { index: 143, name: '182', lat: 44.398 , lng: 21.3993, sys: 2},
        { index: 144, name: '183', lat: 44.3963 , lng: 21.4015, sys: 2},
        { index: 145, name: 'P-05', lat: 44.3958 , lng: 21.402, sys: 1, portal: true}
    ],
    paths: [
        {
            OHLs: ['DV 102B/2 TS POŽAREVAC - TS PETROVAC'],
            path: [{ index: 1, name: 'P-05', lat: 44.6539 , lng: 21.1897, sys: 1, portal: true}, { index: 2, name: '41', lat: 44.6534, lng: 21.1905, sys: 2 }]
        },
        {
            OHLs: ['DV 102A/2 TS POŽAREVAC - TS PETROVAC', 'DV 102B/2 TS POŽAREVAC - TS PETROVAC'],
            position: 'L',
            path: [
                { index: 2, name: '41', lat: 44.6534, lng: 21.1905, sys: 2 },
                { index: 3, name: '42', lat: 44.6522, lng: 21.1934, sys: 2 },
                { index: 4, name: '43', lat: 44.651, lng: 21.1961, sys: 2 },
                { index: 5, name: '44', lat: 44.65, lng: 21.1983, sys: 2 },
                { index: 6, name: '45', lat: 44.6491, lng: 21.2002, sys: 2 },
                { index: 7, name: '46', lat: 44.6481, lng: 21.2032, sys: 2 },
                { index: 8, name: '47', lat: 44.647, lng: 21.2064, sys: 2 },
                { index: 9, name: '48', lat: 44.6459, lng: 21.2096, sys: 2 },
                { index: 10, name: '49', lat: 44.6448, lng: 21.2128, sys: 2 },
                { index: 11, name: '50', lat: 44.6437, lng: 21.2159, sys: 2 },
                { index: 12, name: '51', lat: 44.644, lng: 21.219, sys: 2 },
                { index: 13, name: '52', lat: 44.6443, lng: 21.2223, sys: 2 },
                { index: 14, name: '53', lat: 44.6445, lng: 21.2254, sys: 2 },
                { index: 15, name: '54', lat: 44.6448, lng: 21.2286, sys: 2 },
                { index: 16, name: '55', lat: 44.6451, lng: 21.2319, sys: 2 },
                { index: 17, name: '56', lat: 44.6454, lng: 21.2352, sys: 2 },
                { index: 18, name: '57', lat: 44.6457, lng: 21.2385, sys: 2 },
                { index: 19, name: '58', lat: 44.646, lng: 21.2417, sys: 2 },
                { index: 20, name: '59', lat: 44.6463, lng: 21.2451, sys: 2 },
                { index: 21, name: '60', lat: 44.6465, lng: 21.2485, sys: 2 },
                { index: 22, name: '61', lat: 44.6468, lng: 21.251, sys: 2 },
                { index: 23, name: '62', lat: 44.6454, lng: 21.2533, sys: 2 },
                { index: 24, name: '63', lat: 44.6441, lng: 21.2553, sys: 2 },
                { index: 25, name: '64', lat: 44.6428, lng: 21.2573, sys: 2 },
                { index: 26, name: '65', lat: 44.6406, lng: 21.2583, sys: 2 },
                { index: 27, name: '66', lat: 44.6383, lng: 21.2592, sys: 2 },
                { index: 28, name: '67', lat: 44.6362, lng: 21.2601, sys: 2 },
                { index: 29, name: '68', lat: 44.634, lng: 21.261, sys: 2 },
                { index: 30, name: '69', lat: 44.6317, lng: 21.2619, sys: 2 },
                { index: 31, name: '70', lat: 44.6294, lng: 21.2628, sys: 2 },
                { index: 32, name: '71', lat: 44.6272, lng: 21.2637, sys: 2 },
                { index: 33, name: '72', lat: 44.625, lng: 21.2652, sys: 2 },
                { index: 34, name: '73', lat: 44.623, lng: 21.2665, sys: 2 },
                { index: 35, name: '74', lat: 44.6207, lng: 21.268, sys: 2 },
                { index: 36, name: '75', lat: 44.6188, lng: 21.2693, sys: 2 },
                { index: 37, name: '76', lat: 44.6167, lng: 21.2706, sys: 2 },
                { index: 38, name: '77', lat: 44.6147, lng: 21.2719, sys: 2 },
                { index: 39, name: '78', lat: 44.6125, lng: 21.2719, sys: 2 },
                { index: 40, name: '79', lat: 44.6102, lng: 21.2719, sys: 2 },
                { index: 41, name: '80', lat: 44.608, lng: 21.2719, sys: 2 },
                { index: 42, name: '81', lat: 44.606, lng: 21.2719, sys: 2 },
                { index: 43, name: '82', lat: 44.6038, lng: 21.2719, sys: 2 },
                { index: 44, name: '83', lat: 44.6018, lng: 21.2729, sys: 2 },
                { index: 45, name: '84', lat: 44.5998, lng: 21.2739, sys: 2 },
                { index: 46, name: '85', lat: 44.5975, lng: 21.275, sys: 2 },
                { index: 47, name: '86', lat: 44.5954, lng: 21.2761, sys: 2 },
                { index: 48, name: '87', lat: 44.5932, lng: 21.2772, sys: 2 },
                { index: 49, name: '88', lat: 44.591, lng: 21.2783, sys: 2 },
                { index: 50, name: '89', lat: 44.5889, lng: 21.2793, sys: 2 },
                { index: 51, name: '90', lat: 44.5869, lng: 21.2803, sys: 2 },
                { index: 52, name: '91', lat: 44.5849, lng: 21.282, sys: 2 },
                { index: 53, name: '92', lat: 44.5828, lng: 21.2837, sys: 2 },
                { index: 54, name: '93', lat: 44.5809, lng: 21.2853, sys: 2 },
                { index: 55, name: '94', lat: 44.5789, lng: 21.2869, sys: 2 },
                { index: 56, name: '95', lat: 44.5769, lng: 21.2885, sys: 2 },
                { index: 57, name: '96', lat: 44.575, lng: 21.2901, sys: 2 },
                { index: 58, name: '97', lat: 44.5731, lng: 21.2917, sys: 2 },
                { index: 59, name: '98', lat: 44.5711, lng: 21.2933, sys: 2 },
                { index: 60, name: '99', lat: 44.5692, lng: 21.2949, sys: 2 },
                { index: 61, name: '100', lat: 44.5669, lng: 21.2963, sys: 2 },
                { index: 62, name: '101', lat: 44.5647, lng: 21.2978, sys: 2 },
                { index: 63, name: '102', lat: 44.5625, lng: 21.2992, sys: 2 },
                { index: 64, name: '103', lat: 44.5602, lng: 21.3006, sys: 2 },
                { index: 65, name: '104', lat: 44.5585, lng: 21.3017, sys: 2 },
                { index: 66, name: '105', lat: 44.5562, lng: 21.3032, sys: 2 },
                { index: 67, name: '106', lat: 44.554, lng: 21.3046, sys: 2 },
                { index: 68, name: '107', lat: 44.5518, lng: 21.306, sys: 2 },
                { index: 69, name: '108', lat: 44.5496, lng: 21.3074, sys: 2 },
                { index: 70, name: '109', lat: 44.5474, lng: 21.3089, sys: 2 },
                { index: 71, name: '110', lat: 44.5452, lng: 21.3103, sys: 2 },
                { index: 72, name: '111', lat: 44.543, lng: 21.3118, sys: 2 },
                { index: 73, name: '112', lat: 44.5408, lng: 21.3133, sys: 2 },
                { index: 74, name: '113', lat: 44.5386, lng: 21.3148, sys: 2 },
                { index: 75, name: '114', lat: 44.5363, lng: 21.3163, sys: 2 },
                { index: 76, name: '115', lat: 44.5341, lng: 21.3178, sys: 2 },
                { index: 77, name: '116', lat: 44.532, lng: 21.3192, sys: 2 },
                { index: 78, name: '117', lat: 44.5299, lng: 21.3201, sys: 2 },
                { index: 79, name: '118', lat: 44.5277, lng: 21.321, sys: 2 },
                { index: 80, name: '119', lat: 44.5255, lng: 21.3219, sys: 2 },
                { index: 81, name: '120', lat: 44.5232, lng: 21.3229, sys: 2 },
                { index: 82, name: '121', lat: 44.5209, lng: 21.3239, sys: 2 },
                { index: 83, name: '122', lat: 44.5185, lng: 21.3249, sys: 2 },
                { index: 84, name: '123', lat: 44.5164, lng: 21.3258, sys: 2 },
                { index: 85, name: '124', lat: 44.5142, lng: 21.3267, sys: 2 },
                { index: 86, name: '125', lat: 44.5119, lng: 21.3276, sys: 2 },
                { index: 87, name: '126', lat: 44.5097, lng: 21.3286, sys: 2 },
                { index: 88, name: '127', lat: 44.5075, lng: 21.329, sys: 2 },
                { index: 89, name: '128', lat: 44.5052, lng: 21.3296, sys: 2 },
                { index: 90, name: '129', lat: 44.5028, lng: 21.3301, sys: 2 },
                { index: 91, name: '130', lat: 44.5005, lng: 21.3306, sys: 2 },
                { index: 92, name: '131', lat: 44.4983, lng: 21.3311, sys: 2 },
                { index: 93, name: '132', lat: 44.496, lng: 21.3316, sys: 2 },
                { index: 94, name: '133', lat: 44.4937, lng: 21.3321, sys: 2 },
                { index: 95, name: '134', lat: 44.4914, lng: 21.3327, sys: 2 },
                { index: 96, name: '135', lat: 44.4892, lng: 21.3332, sys: 2 },
                { index: 97, name: '136', lat: 44.4869, lng: 21.3337, sys: 2 },
                { index: 98, name: '137', lat: 44.4847, lng: 21.3342, sys: 2 },
                { index: 99, name: '138', lat: 44.4823, lng: 21.3349, sys: 2 },
                { index: 100, name: '139', lat: 44.4801, lng: 21.3356, sys: 2 },
                { index: 101, name: '140', lat: 44.4778, lng: 21.3363, sys: 2 },
                { index: 102, name: '141', lat: 44.4755, lng: 21.337, sys: 2 },
                { index: 103, name: '142', lat: 44.4733, lng: 21.3377, sys: 2 },
                { index: 104, name: '143', lat: 44.4713, lng: 21.3383, sys: 2 },
                { index: 105, name: '144', lat: 44.4692, lng: 21.339, sys: 2 },
                { index: 106, name: '145', lat: 44.4671, lng: 21.3393, sys: 2 },
                { index: 107, name: '146', lat: 44.465, lng: 21.3396, sys: 2 },
                { index: 108, name: '147', lat: 44.4629, lng: 21.3399, sys: 2 },
                { index: 109, name: '148', lat: 44.4607, lng: 21.3402, sys: 2 },
                { index: 110, name: '149', lat: 44.4587, lng: 21.3405, sys: 2 },
                { index: 111, name: '150', lat: 44.4565, lng: 21.3408, sys: 2 },
                { index: 112, name: '151', lat: 44.4543, lng: 21.3411, sys: 2 },
                { index: 113, name: '152', lat: 44.4518, lng: 21.3414, sys: 2 },
                { index: 114, name: '153', lat: 44.4499, lng: 21.343, sys: 2 },
                { index: 115, name: '154', lat: 44.448, lng: 21.3446, sys: 2 },
                { index: 116, name: '155', lat: 44.4462, lng: 21.346, sys: 2 },
                { index: 117, name: '156', lat: 44.4444, lng: 21.3475, sys: 2 },
                { index: 118, name: '157', lat: 44.4426, lng: 21.3489, sys: 2 },
                { index: 119, name: '158', lat: 44.4407, lng: 21.3504, sys: 2 },
                { index: 120, name: '159', lat: 44.4387, lng: 21.352, sys: 2 },
                { index: 121, name: '160', lat: 44.4367, lng: 21.3537, sys: 2 },
                { index: 122, name: '161', lat: 44.4346, lng: 21.3554, sys: 2 },
                { index: 123, name: '162', lat: 44.4328, lng: 21.3554, sys: 2 },
                { index: 124, name: '163', lat: 44.4309, lng: 21.3554, sys: 2 },
                { index: 125, name: '164', lat: 44.4289, lng: 21.3555, sys: 2 },
                { index: 126, name: '165', lat: 44.4273, lng: 21.358, sys: 2 },
                { index: 127, name: '166', lat: 44.4257, lng: 21.3606, sys: 2 },
                { index: 128, name: '167', lat: 44.424, lng: 21.3631, sys: 2 },
                { index: 129, name: '168', lat: 44.4224, lng: 21.3657, sys: 2 },
                { index: 130, name: '169', lat: 44.4208, lng: 21.3682, sys: 2 },
                { index: 131, name: '170', lat: 44.4192, lng: 21.3707, sys: 2 },
                { index: 132, name: '171', lat: 44.4176, lng: 21.3732, sys: 2 },
                { index: 133, name: '172', lat: 44.4159, lng: 21.3758, sys: 2 },
                { index: 134, name: '173', lat: 44.4143, lng: 21.3784, sys: 2 },
                { index: 135, name: '174', lat: 44.4124, lng: 21.3807, sys: 2 },
                { index: 136, name: '175', lat: 44.4106, lng: 21.3831, sys: 2 },
                { index: 137, name: '176', lat: 44.4088, lng: 21.3855, sys: 2 },
                { index: 138, name: '177', lat: 44.407, lng: 21.3878, sys: 2 },
                { index: 139, name: '178', lat: 44.4051, lng: 21.3901, sys: 2 },
                { index: 140, name: '179', lat: 44.4033, lng: 21.3925, sys: 2 },
                { index: 141, name: '180', lat: 44.4015, lng: 21.3947, sys: 2 },
                { index: 142, name: '181', lat: 44.3998, lng: 21.397, sys: 2 },
                { index: 143, name: '182', lat: 44.398, lng: 21.3993, sys: 2 },
                { index: 144, name: '183', lat: 44.3963, lng: 21.4015, sys: 2 }
            ]
        },
        {
            OHLs: ['DV 102B/2 TS POŽAREVAC - TS PETROVAC'],
            path: [{ index: 144, name: '183', lat: 44.3963, lng: 21.4015, sys: 2 }, { index: 145, name: 'P-05', lat: 44.3958 , lng: 21.402, sys: 1, portal: true}]
        }
    ],
    phaseCross: [
        {name: '109 - 110', position: [{ lat: 44.5474, lng: 21.3089 }, { lat: 44.5452, lng: 21.3103 }], OHLs:['DV 102A/2', 'DV 102B/2 ']},
        {name: '173 - 174', position: [{ lat: 44.4143, lng: 21.3784 }, { lat: 44.4124, lng: 21.3807 }], OHLs:['DV 102A/2', 'DV 102B/2']}
    ]
}